import { ReactNode, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

export type HeaderTagsProps = { entityKey: string } | { variant: 'login' };

function HeaderTags(props: HeaderTagsProps): ReactNode {
 const { t } = useTranslation();

 let title: string;
 let description: string;
 if ('variant' in props) {
  title = t('login.title');
  description = t('login.description');
 } else {
  const label = t(`entities.${props.entityKey}`);
  title = label;
  description = label;
 }

 useEffect(() => {
  const fullTitle = `${title} - Scale Expert`;
  document.title = fullTitle;

  const upsertMetaTag = (attribute: 'name' | 'property', key: string, content: string) => {
   let meta = document.head.querySelector(`meta[${attribute}="${key}"]`) as HTMLMetaElement | null;
   if (!meta) {
    meta = document.createElement('meta');
    meta.setAttribute(attribute, key);
    document.head.appendChild(meta);
   }
   meta.setAttribute('content', content);
  };

  upsertMetaTag('name', 'description', description);
  upsertMetaTag('property', 'og:type', 'website');
  upsertMetaTag('property', 'og:title', title);
  upsertMetaTag('property', 'og:description', description);
 }, [title, description]);

 return null;
}
export default HeaderTags;
